module.exports = {
	"id": "SC",
	"name": "Seychelles",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.010726,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.010726,
			"12": 0.096534,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.016089,
			"21": null,
			"22": 0.005363,
			"23": 0.016089,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.010726,
			"29": 0.058993,
			"30": 0.016089,
			"31": 0.021452,
			"32": 0.010726,
			"33": 0.016089,
			"34": 0.005363,
			"35": 0.010726,
			"36": 0.016089,
			"37": 0.010726,
			"38": 0.026815,
			"39": 0.032178,
			"40": 0.005363,
			"41": 0.032178,
			"42": 0.021452,
			"43": 0.557752,
			"44": 0.016089,
			"45": 0.144801,
			"46": 0.010726,
			"47": 0.026815,
			"48": 0.069719,
			"49": 0.884895,
			"50": 0.654286,
			"51": 6.424874,
			"52": 0.568478,
			"53": 11.814689,
			"54": 3.030095,
			"55": 0.085808,
			"56": 0.010726,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.016089,
			"4": 0.005363,
			"5": 0.010726,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.010726,
			"12": 0.032178,
			"13": null,
			"14": 0.005363,
			"15": null,
			"16": null,
			"17": 0.010726,
			"18": 0.016089,
			"19": 0.005363,
			"20": 0.021452,
			"21": 0.010726,
			"22": 0.016089,
			"23": 0.010726,
			"24": 0.048267,
			"25": 0.005363,
			"26": 0.016089,
			"27": null,
			"28": 0.005363,
			"29": 0.069719,
			"30": 0.230609,
			"31": 0.010726,
			"32": 0.016089,
			"33": 0.026815,
			"34": 0.021452,
			"35": 0.010726,
			"36": 0.048267,
			"37": 0.005363,
			"38": 0.327143,
			"39": 0.128712,
			"40": 0.021452,
			"41": 0.042904,
			"42": 0.225246,
			"43": 0.949251,
			"44": 0.150164,
			"45": 0.332506,
			"46": 0.713279,
			"47": 2.52061,
			"48": 1.120867,
			"49": 4.982227,
			"50": 0.407588,
			"51": null,
			"52": 0.016089,
			"3.5": 0.010726,
			"3.6": 0.016089
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.010726,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.042904,
			"37": 0.010726,
			"38": 1.067237,
			"39": 0.016089,
			"40": 0.26815,
			"41": 0.037541,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.058993
		},
		"safari": {
			"0": null,
			"4": 0.021452,
			"5": null,
			"6": null,
			"7": 0.021452,
			"8": 0.101897,
			"9": 0.139438,
			"10": 1.153045,
			"3.1": null,
			"3.2": null,
			"5.1": 0.048267,
			"6.1": 0.016089,
			"7.1": null,
			"9.1": 0.525574
		},
		"ios_saf": {
			"8": 0,
			"10": 9.74725584929,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.262677266341,
			"8.1-8.4": 0.485285119172,
			"9.0-9.2": 0.231512166944,
			"9.3": 3.53204459825
		},
		"android": {
			"3": 0,
			"4": 0.0416011989664,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0052001498708,
			"4.1": 0.1500614677,
			"4.2-4.3": 0.375153669251,
			"4.4": 0.860253364341,
			"4.4.3-4.4.4": 0.867682149871
		},
		"ie": {
			"6": 0.165934118919,
			"7": null,
			"8": 1.08410291027,
			"9": 0.237838903784,
			"10": 0.320805963243,
			"11": 3.30208896649,
			"5.5": null
		},
		"op_mob": {
			"0": 0.345362168825,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00959339357848
		},
		"edge": {
			"12": 0.42904,
			"13": 0.632834,
			"14": 0.396862
		},
		"ie_mob": {
			"10": 0.11977828169,
			"11": 0.48766871831
		},
		"bb": {
			"7": 0.041733,
			"10": null
		},
		"samsung": {
			"0": 3.969272
		},
		"and_uc": {
			"0": 5.258358
		},
		"op_mini": {
			"0": 4.6530044376
		},
		"and_chr": {
			"0": 16.215427
		},
		"and_ff": {
			"0": 0.060281
		}
	},
	"total": 95.2298538627
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SC.json
 ** module id = 639
 ** module chunks = 0
 **/